/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeListing } from '../models/EmployeeListing';
import type { FacilityStatistics } from '../models/FacilityStatistics';
import { request as __request } from '../core/request';

export class FacilityStatisticsService {

    /**
     * Get the facility statistics
     * @returns FacilityStatistics facility statistics
     * @throws ApiError
     */
    public static async getFacilityStatistics({
companyId,
}: {
/** The companyId **/
companyId: number,
}): Promise<FacilityStatistics> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/facility-statistics`,
        });
        return result.body;
    }

    /**
     * Get a list of employees in a shift
     * @returns EmployeeListing List of employees in this shift
     * @throws ApiError
     */
    public static async getEmployees({
companyId,
shift,
departmentId,
titleId,
}: {
/** The companyId **/
companyId: number,
/** shift type **/
shift?: number,
/** department ID **/
departmentId?: number,
/** title ID **/
titleId?: number,
}): Promise<EmployeeListing> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/facility-statistics/employees`,
            query: {
                'shift': shift,
                'departmentId': departmentId,
                'titleId': titleId,
            },
        });
        return result.body;
    }

}